<template>
  <div 
    style="display: inline-block; vertical-align:top;"
    @click="loadVideo">
    <img style="width: 45px; margin-right: 5px; float: left;" 
      :src="require('../../assets/' + coloredAssetUrls.lightbulb)">
    <span>{{ description }}</span>
  </div>
</template>

<script>
export default {
  name: "BestPracticesEntry",
  props: {
    id: Number,
    description: String, 
    filename: String
  },
  methods: {
    loadVideo(){
      this.$store.dispatch("launchPDF", this.filename);
    }
  }
};
</script>